module.exports = __webpack_public_path__ + "assets/img/linea-temporal-rakumart-logistica.8864cf06.svg";